module.exports = __webpack_public_path__ + "static/media/hero.feda6f55.jpg";